
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default BaseCmsBlock.extend({
  name: "TransportTypeSliderBlock",

  data: function () {
    return {
      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 1.2,
        slidesPerGroup: 1,

        breakpoints: {
          1200: {
            slidesPerView: 4.5,
            slidesPerGroup: 4.5,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          860: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
        },
        navigation: {
          prevEl: '.transport-type-slider-block__button-navition--prev',
          nextEl: '.transport-type-slider-block__button-navition--next'
        },
      },
    }
  },

  components: {
    Swiper,
    SwiperSlide,

    Card: () => import("~/components/category/ProductCardSmallImage.vue")
  },

  computed: {
    localValues: function () {
      return this.externalData?.TransportTypeSliderBlock || this.values || {}
    },
    useH1: function () {
      return this.localValues?.useH1 || false
    }
  }
})
